import { render, staticRenderFns } from "./CompanyWrapper.vue?vue&type=template&id=154e302d"
import script from "./CompanyWrapper.vue?vue&type=script&lang=js"
export * from "./CompanyWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports